import { render, staticRenderFns } from "./FooterTable.vue?vue&type=template&id=4bd75e58&"
import script from "./FooterTable.vue?vue&type=script&lang=js&"
export * from "./FooterTable.vue?vue&type=script&lang=js&"
import style0 from "./FooterTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports